// Animate account menu closed, then remove [open]
function closeAccountMenu(details)
{
  details.classList.add('is-closing');
  setTimeout(() =>
  {
    details.removeAttribute('open');
    details.classList.remove('is-closing');
  }, 280);
}

export function addSiteListeners()
{
  // Intercept summary click on an already-open account menu to animate close
  document.addEventListener(
    'click',
    function (e)
    {
      const summary = e.target.closest('.account-menu-details > summary');
      if (summary)
      {
        const details = summary.closest('.account-menu-details');
        if (details.open)
        {
          e.preventDefault();
          closeAccountMenu(details);
        }
      }
    },
    true,
  ); // capture phase so we run before the browser toggles [open]

  document.addEventListener('click', function (e)
  {
    // Close account dropdown when clicking outside or when opening the main nav
    if (!e.target.closest('.account-menu-details'))
    {
      document
        .querySelectorAll('.account-menu-details[open]')
        .forEach(closeAccountMenu);
    }
  });
}
